module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=MC - Monaco.ed8883b8.svg";